import * as React from 'react';
import { ArrayHelper, Slug } from '@fnv-core/utils';
import { ICheckboxMultipleFieldDefinition, IOption } from '../interfaces/Fields';
import { PropertyHelpers } from '../helpers/PropertyHelpers';
import { FormControlProps } from '../interfaces/FormControlProps';
import { LabelAndPopover } from './components/label-and-popover';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { CheckboxControl } from '../presentational/controls/CheckboxControl';
import { ComponentStoreHelpers } from './helpers/ComponentStoreHelpers';

interface ICheckboxOption extends IOption {
  checked: boolean;
}

export interface CheckboxMultipleState {
  selectedValues: string[];
  dataSourceCounter: number;
  timer: any;
}

export class CheckboxMultiple extends React.Component<FormControlProps, CheckboxMultipleState> {

  private _checkboxFieldDefinition: ICheckboxMultipleFieldDefinition;

  constructor(props: FormControlProps) {
    super(props);

    this.state = {
      selectedValues: [],
      dataSourceCounter: 0,
      timer: undefined,
    };
    this._checkboxFieldDefinition = this.props.formFieldDefinition as ICheckboxMultipleFieldDefinition;

    this.onSelectAllChanged = this.onSelectAllChanged.bind(this);
  }

  componentDidMount(): void {
    if (ComponentStoreHelpers.hasDatasource(this)) {
      ComponentStoreHelpers.setFormFieldData(this, []);
      ComponentStoreHelpers.getData(this).then(data => {
        if (this.unmounted) {
          return;
        }

        const options = ComponentStoreHelpers.getListData(this);
        const optionValues = options.map(opt => opt.value);
        const selectedValues = this.props.field.value ? optionValues.filter(ov => this.props.field.value.some(v => {
          if (v.value) {
            return v.value === ov;
          }
          return v === ov;
        })) : [];
        this.setState({
          selectedValues,
        });
      });
    } else {
      this.setState({
        selectedValues: [],
      });
    }
  }

  unmounted: boolean = false;
  componentWillUnmount() {
    this.unmounted = true;
  }

  private getSelectedItems(selectedValues?: string[]): IOption[] {
    const allOptions = ComponentStoreHelpers.getListData(this);
    if (!selectedValues) {
      return allOptions;
    }

    const selectedItems = allOptions.filter(o => selectedValues.indexOf(o.value) > -1);
    return selectedItems;
  }

  private onChange(option: IOption, checked: boolean) {
    const currentSelected = [...this.state.selectedValues];

    const currentIndex = currentSelected.indexOf(option.value);
    if (checked) {
      // Add if not already in the selected values
      if (currentIndex === -1) {
        currentSelected.push(option.value);
      }
    } else {
      // Remove if in the selected values
      if (currentIndex > -1) {
        currentSelected.splice(currentIndex, 1);
      }
    }

    const selectedItems = this.getSelectedItems(currentSelected);

    const properties = FormControlHelpers.inputProperties(this);
    properties.onChange({
      target: {
        value: selectedItems,
      }
    });

    this.setState({
      selectedValues: currentSelected,
    });

    return false;
  }

  private onSelectAllChanged(selectAllChecked: boolean) {
    const selectedItems = selectAllChecked ? this.getSelectedItems() : [];

    if (selectAllChecked) {
      this.setState({
        selectedValues: selectedItems.map(i => i.value),
      });
    } else {
      this.setState({
        selectedValues: [],
      });
    }

    const properties = FormControlHelpers.inputProperties(this);
    properties.onChange({
      target: {
        value: selectedItems,
      }
    });
  }

  render() {
    
    let options: IOption[] = ComponentStoreHelpers.getListData(this);
    if (this._checkboxFieldDefinition.sortItems) {
      options = ArrayHelper.sortBy(options, 'label');
    }

    const displaySelectAll = this._checkboxFieldDefinition.selectAll;
    
    return(
      <div className={'form-group form-checkboxmultiple-group checkbox-multiple ' + this.props.visibilityClass + ' ' + Slug.fromString(this._checkboxFieldDefinition.name) + "-checkboxmultiple-form-group"}>
        {(this._checkboxFieldDefinition.label || !!this._checkboxFieldDefinition.hasPopover) ? (
          <LabelAndPopover 
            className="form__checkbox"
            fieldId={PropertyHelpers.getFieldID(this.props)} 
            label={FormLabelHelpers.getFieldLabel(this)}
            explanation={this._checkboxFieldDefinition.explanation}
            hasPopover={this._checkboxFieldDefinition.hasPopover}
          ></LabelAndPopover>
        ) : null}
        {
          displaySelectAll && 
            <div className="checkbox-multiple__select-all">
              <CheckboxControl
                id={this._checkboxFieldDefinition.name + 'option-selectAll'}
                checked={this.state.selectedValues.length === options.length}
                label={'<strong>' + this._checkboxFieldDefinition.selectAllText || '(De)selecteer alles' + '</strong>'}
                onChange={(checked) => this.onSelectAllChanged(checked)}
                />
            </div>
        }
        <div className="checkbox-multiple__choices">
          {options.map((option, index) => (
            <CheckboxControl
              key={'key-' + option.value}
              id={this._checkboxFieldDefinition.name + '-option-' + index}
              checked={this.state.selectedValues?.indexOf(option.value) > -1}
              label={option.label}
              onChange={(checked: boolean) => this.onChange(option, checked)}
              />
          ))}
        </div>
        {FormControlHelpers.invalidFeedbackComponent(this)}
      </div>
    );
  }
}
